// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"f48259d4","187":"08d0b78e","205":"967e43cd","466":"526f2496","494":"e839c803","524":"9df8f1ca","537":"2b5ea27f","702":"14b5c3fd","711":"7073f957","770":"29dc9841","781":"09dd6c66","910":"260a927d"}[chunkId] + ".chunk.js";
};